<template>
    <div class="container">
        <v-card>
            <v-card-title class="titulopagina">PRODUCCION DE HARINA</v-card-title>
            <v-card-text>
                <v-row>
                    <!-- <v-col cols="2" sm="3">
                        <v-select
                            v-model="turno"
                            :items="turnos"
                            item-text="nombre_turno"
                            item-value="id"
                            label="Elija Turno"
                            color="blue darken-3"
                            persistent-hint
                            return-object
                            @change="cargarDatos"
                        >
                        </v-select>
                    </v-col> -->
                    <v-col cols="2" sm="3">
                        <date-picker class="dtpicker" v-model="fecha" @change="cargarDatos" format="DD-MM-YYYY" valueType="YYYY-MM-DD"></date-picker>
                    </v-col>
                    <v-col cols="2" sm="3">
                        <v-btn color="success" @click="guardarProduccion">Grabar producción</v-btn>
                    </v-col>
                    <v-col cols="8" sm="6" v-if="alert">
                        <v-alert dense text type="success">
                        Producción día Guardada Correctamente <strong>!</strong> <v-btn icon class="float-right" color="green darken-3" @click="alert=!alert"><v-icon>cancel</v-icon></v-btn>
                        </v-alert>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <!-- <v-card class="mt-5">
            <v-card-text>
                
            </v-card-text>
        </v-card> -->
        
        <!-- <v-data-table 
                    :headers="cabeceras"
                    :items="lista"
                    class="elevation-1 mt-5"
                    dense
                >
                    <template v-slot:item.jumbos="prop">
                        <v-btn @click="verJumbos(prop.item)" icon><v-icon>visibility</v-icon></v-btn>
                            <v-checkbox v-for="jumbo in prop.item.jumbos" :key="jumbo"  v-model="jumbo.confirmar" :label="`${jumbo.control_planta_prefijo}${jumbo.control_planta_correlativo}`"></v-checkbox>
                    </template>
                    <template v-slot:item.cantidad_jumbos="prop">
                        <v-text-field v-model="prop.item.cantidad_jumbos" type="number" outlined dense></v-text-field>
                    </template>
                    <template v-slot:item.total_kg="prop">
                        <v-text-field v-model="prop.item.total_kg" type="number" outlined dense></v-text-field>
                    </template>
        </v-data-table> -->


        
        <!-- detalle jumbos -->
        <v-card>
            <v-simple-table>
                <thead>
                    <tr>
                        <th class="text-center blue darken-4">Linea</th>
                        <th class="text-center blue darken-4">Materia Prima</th>
                        <th class="text-center blue darken-4">Maxisacos (PA'S)</th>
                        <th class="text-center blue darken-4">Cantidad Maxisacos Sistema</th>
                        <th class="text-center blue darken-4">Cantidad Consolidada</th>
                        <th class="text-center blue darken-4">Total Kilos Sistema</th>
                        <th class="text-center blue darken-4">Total Consolidado</th>
                        <!-- <th class="text-center">Cantidad Maxisacos</th> -->
                        <th class="text-center blue darken-4">Peso Por Maxisaco (Kg Aprox.)</th>
                        <th class="text-center blue darken-4">Produccion (Kg)</th>
                        <th class="text-center blue darken-4">Materia Prima Producción</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item,idx) in lista" :key="item.id">
                        <td class="text-center">{{item.id?item.linea.nombre_linea:item.linea}}</td>
                        <td class="text-center">{{item.id?item.tipo_mp.tipo_materia_prima:item.materia_prima}}</td>
                        <td class="text-center"><v-btn @click="verJumbos(item)" icon><v-icon>visibility</v-icon></v-btn></td>
                        <td class="text-center">{{item.cantidad_jumbos_sistema}}</td>
                        <td class="text-center">{{item.cantidad_jumbos}}</td>
                        <td class="text-center">{{item.total_kilos_sistema}}</td>
                        <td class="text-center">{{item.produccion}}</td>
                        <!-- <td class="text-center"><v-text-field v-model="item.cantidad_jumbos" type="number" outlined dense></v-text-field></td> -->
                        <td class="text-center">{{item.peso_aproximado_jumbo}}</td>
                        <td class="text-center"><v-text-field class="mt-1" v-model="item.produccion" type="number" outlined dense @input="calcularPesoJumbo(idx,item)"></v-text-field></td>
                        <td class="text-center"><v-text-field v-model="item.mp_procesada" type="number" outlined dense></v-text-field></td>
                    </tr>

                    <!-- jumbos que aun no han sido asignados (solo tienen PA) -->
                    <tr v-for="(item) in jumbos_sin_asignar" :key="item.id" style="background-color:#FFECB3;">
                        <td class="text-center">{{item.id?item.linea.nombre_linea:item.linea}}</td>
                        <td class="text-center">{{item.id?item.tipo_mp.tipo_materia_prima:item.materia_prima}}</td>
                        <td class="text-center"><v-btn @click="verJumbos(item)" icon><v-icon>visibility</v-icon></v-btn></td>
                        <td class="text-center">{{item.cantidad_jumbos_sistema}}</td>
                        <td class="text-center"></td>
                        <td class="text-center"></td>
                        <td class="text-center"></td>
                        <!-- <td class="text-center"><v-text-field v-model="item.cantidad_jumbos" type="number" outlined dense></v-text-field></td> -->
                        <td class="text-center"></td>
                        <td class="text-center"></td>
                        <td class="text-center"></td>
                    </tr>
                    <!-- jumbos que aun no han sido asignados (solo tienen PA) -->

                    <!-- jumbos que aun no han sido asignados (solo tienen PA) -->
                    <tr v-for="(item) in jumbos_reprocesados" :key="item.id" style="background-color:#CCC;">
                        <td class="text-center">{{item.id?item.linea.nombre_linea:item.linea}}</td>
                        <td class="text-center">{{item.id?item.tipo_mp.tipo_materia_prima:item.materia_prima}}</td>
                        <td class="text-center"><v-btn @click="verJumbos(item)" icon><v-icon>visibility</v-icon></v-btn></td>
                        <td class="text-center">{{item.cantidad_jumbos_sistema}}</td>
                        <td class="text-center">{{item.cantidad_jumbos}}</td>
                        <td class="text-center">{{item.total_kilos_sistema}}</td>
                        <td class="text-center">{{item.produccion}}</td>
                        <!-- <td class="text-center"><v-text-field v-model="item.cantidad_jumbos" type="number" outlined dense></v-text-field></td> -->
                        <td class="text-center">{{item.peso_aproximado_jumbo}}</td>
                        <td class="text-center"> </td>
                        <td class="text-center"> </td>
                    </tr>
                    <!-- jumbos que aun no han sido asignados (solo tienen PA) -->

                    <!-- jumbos de barrido (solo informativo) -->
                    <tr v-for="(item) in jumbos_de_barrido" :key="item.id" style="background-color:#CCC;">
                        <td class="text-center">{{item.id?item.linea.nombre_linea:item.linea}}</td>
                        <td class="text-center">{{item.id?item.tipo_mp.tipo_materia_prima:item.materia_prima}}</td>
                        <td class="text-center"><v-btn @click="verJumbos(item)" icon><v-icon>visibility</v-icon></v-btn></td>
                        <td class="text-center">{{item.cantidad_jumbos_sistema}}</td>
                        <td class="text-center">{{item.cantidad_jumbos}}</td>
                        <td class="text-center">{{item.total_kilos_sistema}}</td>
                        <td class="text-center">{{item.produccion}}</td>
                        <!-- <td class="text-center"><v-text-field v-model="item.cantidad_jumbos" type="number" outlined dense></v-text-field></td> -->
                        <td class="text-center">{{item.peso_aproximado_jumbo}}</td>
                        <td class="text-center"> </td>
                        <td class="text-center"> </td>
                    </tr>
                    <!-- jumbos de barrido (solo informativo) -->

                    <tr>
                        <td class="text-center"></td>
                        <td class="text-center"></td>
                        <td class="text-center"></td>
                        <td class="text-center"><h3><strong>{{totales.total_jumbos_sistema}}</strong></h3></td>
                        <td class="text-center"><h3><strong>{{totales.total_jumbos_prod}}</strong></h3></td>
                        <td class="text-center"><h3><strong>{{totales.total_kilos_sistema | formatear_miles}}</strong></h3></td>
                        <td class="text-center"><h3><strong>{{totales.total_kilos_produccion | formatear_miles}}</strong></h3></td>
                        <td class="text-center"></td>
                        <td class="text-center"><h3><strong>{{totales.total_kilos_produccion | formatear_miles}}</strong></h3></td>
                        <td class="text-center"><h3><strong>{{totales.total_kilos_mmpp | formatear_miles}}</strong></h3></td>
                    </tr>

                </tbody>
            </v-simple-table>
        </v-card>
        
        <!-- <pre>{{lista}}</pre> -->

        <v-dialog
            v-model="abrir_modal"
            width="500"
        >

            <v-card>
                <v-card-title
                    class="headline grey lighten-2"
                    primary-title
                    >
                    Detalle de Maxisacos sistema
                </v-card-title>

                <v-card-text>
                    <v-row>
                        <v-col >
                            {{`${produccion.pe_as}`}}
                        </v-col>

                        <!-- <v-col v-for="jumbo in produccion.pe_as" :key="jumbo.resultado_id">
                            {{`${produccion.control_planta_prefijo}${produccion.pe_as}`}}
                        </v-col> -->
                    </v-row>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        text
                        @click="abrir_modal = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="abrir_modal2"
            width="500"
        >

            <v-card>
                <v-card-title
                    class="headline grey lighten-2"
                    primary-title
                    >
                    Detalle de Maxisacos Consolidados
                </v-card-title>

                <v-card-text>
                    <v-row>
                        <v-col >
                            {{`${produccion.jumbos}`}}
                        </v-col>

                        <!-- <v-col v-for="jumbo in produccion.pe_as" :key="jumbo.resultado_id">
                            {{`${produccion.control_planta_prefijo}${produccion.pe_as}`}}
                        </v-col> -->
                    </v-row>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        text
                        @click="abrir_modal2 = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    <!-- detalle jumbos -->

    </div>
</template>
<script>
import {mapState, mapMutations} from 'vuex';
//import Tabla from '@/components/shared/Tabla.vue'
import Data_Table from '@/components/shared/Data_Table.vue';
import Modal from '@/components/shared/Modal.vue';
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
// import axios from 'axios'
export default {
    data:()=>({
        turno: [],
        lista:[],
        jumbos_sin_asignar:[],
        jumbos_reprocesados:[],
        jumbos_de_barrido:[],
        turnos: [],
        alert:false,
        fecha: new Date().toISOString().substr(0, 10),
        mostrar_fecha: false,
        abrir_modal:false,
        abrir_modal2:false,
        produccion:{},
        //configuracion para datatable
        cabeceras:[
            {
                text: 'Linea',
                align: 'center',
                sortable: true,
                value: 'linea',
            },
            {
                text: 'Maxisacos',
                align: 'center',
                sortable: true,
                value: 'jumbos',
            },
            {
                text: 'Materia prima',
                align: 'center',
                sortable: true,
                value: 'materia_prima',
            },
            {
                text: 'Cantidad Maxisacos',
                align: 'center',
                sortable: true,
                value: 'cantidad_jumbos',
            },
            {
                text: 'Total Kilos',
                align: 'center',
                sortable: true,
                value: 'total_kg',
            }
        ],
        acciones:[]
    }),
    mounted() {
        //this.cargarTurnos();
    },
    methods: {
        async cargarTurnos(){
            let url = `${this.base_url}turnos`;
            await this.axios.get(url,this.headers).then((response)=>{
                this.turnos = response.data.data;
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            });
        },
        async cargarDatos(){
            this.lista = [];
            //this.mostrarLoading('Cargando Datos...');
            let url = `${this.base_url}produccion_turno/fecha/${this.fecha}`;
            await this.axios.get(url, this.headers).then((response)=>{
                this.lista = response.data.items_con_jumbos;
                this.jumbos_sin_asignar = response.data.items_sin_jumbos;
                this.jumbos_reprocesados = response.data.jumbos_reprocesados;
                this.jumbos_de_barrido = response.data.jumbos_de_barrido;
                this.lista.forEach((item,idx) => {
                    let peso = item.produccion / item.cantidad_jumbos_sistema;
                    this.$set(this.lista[idx],'peso_aproximado_jumbo',Math.round(peso));
                });
                Event.$emit('inicializar_tabla',this.cabeceras,this.lista,this.acciones);
                this.ocultarLoading();
            }).catch((error)=>{
                this.errorMessage(error, "Error al cargar datos ");
            });
        },

        calcularPesoJumbo(idx,item){
            let peso = item.produccion / item.cantidad_jumbos_sistema;
            this.$set(this.lista[idx],'peso_aproximado_jumbo',Math.round(peso))
            //cantidad_jumbos_sistema,
        },
        async guardarProduccion(){
            // let body = `{"data":[`;
            let b = {data:[]};
            // let coma = ""; 
            let length = this.lista.length - 1;
            //this.mostrarLoading('Guardando Producción...');
            this.mostrarLoading({titulo:'Guardando Producción...',color:'green'})

            this.lista.forEach((pro,index) => {
                console.log(pro.jumbos_id);
                b.data.push(
                    {
                        id:pro.id,
                        fecha:this.fecha,
                        turnos_id:this.turno.id,
                        tipo_mps_id:pro.tipo_mps_id,
                        cantidad_jumbos:pro.cantidad_jumbos,
                        cantidad_jumbos_sistema:pro.cantidad_jumbos_sistema,
                        produccion:pro.produccion,
                        mp_procesada:pro.mp_procesada,
                        tipo_produccion_id:1,
                        peso_aproximado_jumbo:pro.peso_aproximado_jumbo,
                        jumbos:pro.jumbos,
                        jumbos_id:pro.jumbos_id,
                        lineas_id:pro.lineas_id
                    }
                );
            });
            
            let url = `${this.base_url}produccion_turno/guardar`;
            await this.axios.post(url,b,this.headers).then((res)=>{
                this.ocultarLoading();
                console.log('realizado',res.data);
                this.alert=true;
                this.cargarDatos();
            }).catch((error)=>{
                this.alert=false;
                this.errorMessage(error, "Error al grabar producción ");
            });
        },

        verJumbos(item){
            console.log(item);
            this.produccion = item;
            this.abrir_modal = true;
        },

        verJumbos2(item){
            console.log(item);
            this.produccion = item;
            this.abrir_modal2 = true;
        },

        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url','headers']),

        totales(){
            return {
                total_jumbos_sistema: this.lista.reduce((a, b) => a + b.cantidad_jumbos_sistema, 0),
                total_jumbos_prod: this.lista.reduce((a, b) => a + b.cantidad_jumbos, 0),
                total_kilos_sistema: this.lista.reduce((a, b) => a + Number(b.total_kilos_sistema), 0),
                total_kilos_produccion: this.lista.reduce((a, b) => a + Number(b.produccion), 0),
                total_kilos_mmpp: this.lista.reduce((a, b) => a + Number(b.mp_procesada), 0),
            }
        },

        fecha_formateada () {
          return this.fecha ? this.moment(this.fecha).format('DD-MM-YYYY') : '';
        }
    },
    components:{
        'modal':Modal,
        'data-table':Data_Table,
        DatePicker
    }
}
</script>
<style scoped>
    .mx-datepicker{
        width: 100% !important;
    }

    input[type=number]{
        text-align: right;
    }
    th {color: white !important; font-size: 0.9em !important; }
    td {border-right:0.5px #00897B solid;}

/**quitar las flechitas */
    /* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>